const time = new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit' });
const weekday = new Intl.DateTimeFormat('de-DE', { weekday: 'short' });
const dayMonth = new Intl.DateTimeFormat('de-DE', { day: 'numeric', month: 'short' });
const full = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });

function startOfDay(d: Date) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/** Zeitangabe für die Aufgabenliste, wie bei WhatsApp. */
export function listTime(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  const days = Math.round((startOfDay(new Date()) - startOfDay(d)) / 86_400_000);
  if (days <= 0) return time.format(d);
  if (days === 1) return 'Gestern';
  if (days < 7) return weekday.format(d);
  return dayMonth.format(d);
}

export const clock = (iso: string) => time.format(new Date(iso));

export function dayLabel(iso: string): string {
  const d = new Date(iso);
  const days = Math.round((startOfDay(new Date()) - startOfDay(d)) / 86_400_000);
  if (days === 0) return 'Heute';
  if (days === 1) return 'Gestern';
  return full.format(d);
}

export const shortDate = (iso: string) => dayMonth.format(new Date(iso));

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] ?? '') + (parts.length > 1 ? parts.at(-1)![0] : (parts[0]?.[1] ?? ''))).toUpperCase();
}

// Wörter, die im Kürzel einer Aufgabe nichts unterscheiden
const FUELLWOERTER = new Set(['der', 'die', 'das', 'den', 'dem', 'des', 'ein', 'eine', 'einen', 'einem', 'einer', 'und', 'oder', 'für', 'mit', 'von', 'vom', 'zum', 'zur', 'im', 'in', 'am', 'an', 'auf', 'aus', 'bei', 'nach', 'zu', 'bis', 'über', 'the', 'a', 'of', 'for', 'and', 'to']);

/**
 * Kürzel für eine Aufgabe: Anfangsbuchstaben der ersten beiden tragenden
 * Wörter („Angebot für die Bäckerei" → „AB"), damit sich Aufgaben desselben
 * Projekts in der schmalen Leiste unterscheiden.
 */
export function taskInitials(title: string): string {
  const words = title.replace(/[^\p{L}\p{N}\s-]/gu, ' ').split(/[\s-]+/).filter(Boolean);
  const tragend = words.filter((w) => !FUELLWOERTER.has(w.toLowerCase()));
  const w = tragend.length ? tragend : words;
  if (!w.length) return '?';
  const kuerzel = w.length > 1 ? w[0]![0]! + w[1]![0]! : w[0]!.slice(0, 2);
  return kuerzel.toUpperCase();
}

const GRADIENTS = [
  ['#FF8A5B', '#FF5E7E'],
  ['#38E0B4', '#2EC5FF'],
  ['#6C63FF', '#B18CFF'],
  ['#FFB547', '#FF7A45'],
  ['#2EC5FF', '#6C63FF'],
  ['#F472B6', '#A78BFA'],
];

/** Stabile Verlaufsfarbe aus einer ID. */
export function avatarGradient(seed: string): string {
  let h = 0;
  for (const ch of seed) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  const [a, b] = GRADIENTS[h % GRADIENTS.length]!;
  return `linear-gradient(135deg, ${a}, ${b})`;
}

const URL_RE = /https?:\/\/[^\s<>"]+/i;
export const findUrl = (text: string) => text.match(URL_RE)?.[0] ?? null;
